angular.module('app.routes').config(($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider, $provide, routeResolver) => {
    const getView = (viewName) => `/app/${viewName}.html`;

    // Use $urlRouterProvider to configure any redirects (when) and invalid urls (otherwise).
    $urlRouterProvider.when('/dashboard', '/').otherwise('/login');

    // allow to use anchors
    $locationProvider.html5Mode(true);

    // obsługa filtrow
    $provide.decorator('$state', ($delegate) => {
        $delegate.applyFilter = (filterValues) =>
            $delegate.go(
                $delegate.current,
                { filter: filterValues },
                {
                    reload: false,
                    inherit: false,
                    notify: false,
                }
            );
        return $delegate;
    });

    $stateProvider

        // -- ERROR PAGES --

        .state('error', {
            url: '/error',
            templateUrl: getView('error/default'),
            permissions: true,
        })
        .state('error.404', {
            url: '/404',
            templateUrl: getView('error/404'),
            permissions: true,
        })
        .state('error.500', {
            url: '/500',
            templateUrl: getView('error/500'),
            permissions: true,
        })

        // -- LOGIN PAGE --

        .state('login', {
            url: '/login',
            templateUrl: getView('auth/login'),
            controller: 'AuthLoginCtrl',
            controllerAs: 'AuthLogin',
            permissions: true,
        })

        .state('check-session', {
            url: '/check-session',
            template: '<!-- -->',
            controller: 'AuthCheckCtrl',
            controllerAs: 'AuthCheck',
            permissions: false,
        })

        // -- RESTRICTED --

        .state('restricted', {
            abstract: true,
            url: '',
            views: {
                main_header: {
                    templateUrl: getView('header/main_header'),
                    controller: 'MainHeaderCtrl',
                    controllerAs: 'MainHeader',
                },
                main_sidebar: {
                    templateUrl: getView('aside/main_aside'),
                    controller: 'MainAsideCtrl',
                    controllerAs: 'MainAside',
                },
                '': {
                    templateUrl: getView('app/restricted'),
                },
            },
            resolve: {
                areasListForUser: routeResolver.areasListForUser,
            },
        })

        // dashboards

        .state('restricted.dashboard_main', {
            url: '/',
            views: {
                '': {
                    templateUrl: getView('dashboard/dashboard_default'),
                    controller: 'DashboardDefaultCtrl',
                    controllerAs: 'DashboardDefault',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
            },
            data: {
                pageTitle: 'dashboard_main',
                permissions: true,
            },
        })
        .state('restricted.dashboard_tasks', {
            url: '/dashboard/tasks',
            views: {
                '': {
                    templateUrl: getView('dashboard/dashboard_tasks'),
                    controller: 'DashboardTasksCtrl',
                    controllerAs: 'DashboardTasks',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
            },
            data: {
                pageTitle: 'dashboard_tasks',
                permissions: { tasks__read_all: 0, tasks__read: 'CUID' },
            },
        })
        .state('restricted.dashboard_measurement', {
            url: '/dashboard/measurement',
            views: {
                '': {
                    templateUrl: getView('dashboard/dashboard_phase'),
                    controller: 'DashboardPhaseCtrl',
                    controllerAs: 'DashboardPhase',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
                groupsOptions: routeResolver.groupsOptions,
                phaseStatusOptions: routeResolver.phaseStatusOptions,
            },
            data: {
                pageTitle: 'dashboard_measurement',
                permissions: { dashboard_measurement__read_all: 0, dashboard_measurement__read: 'CUID' },
                dashboardType: 'measurement',
            },
        })
        .state('restricted.dashboard_installation', {
            url: '/dashboard/installation',
            views: {
                '': {
                    templateUrl: getView('dashboard/dashboard_phase'),
                    controller: 'DashboardPhaseCtrl',
                    controllerAs: 'DashboardPhase',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
                groupsOptions: routeResolver.groupsOptions,
                phaseStatusOptions: routeResolver.phaseStatusOptions,
            },
            data: {
                pageTitle: 'dashboard_installation',
                permissions: { dashboard_installation__read_all: 0, dashboard_installation__read: 'CUID' },
                dashboardType: 'installation',
            },
        })
        .state('restricted.dashboard_transport', {
            url: '/dashboard/transport',
            views: {
                '': {
                    templateUrl: getView('dashboard/dashboard_phase'),
                    controller: 'DashboardPhaseCtrl',
                    controllerAs: 'DashboardPhase',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
                groupsOptions: routeResolver.groupsOptions,
                phaseStatusOptions: routeResolver.phaseStatusOptions,
            },
            data: {
                pageTitle: 'dashboard_transport',
                permissions: { dashboard_transport__read_all: 0, dashboard_transport__read: 'CUID' },
                dashboardType: 'transport',
            },
        })
        .state('restricted.dashboard_service', {
            url: '/dashboard/service',
            views: {
                '': {
                    templateUrl: getView('dashboard/dashboard_phase'),
                    controller: 'DashboardPhaseCtrl',
                    controllerAs: 'DashboardPhase',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
                groupsOptions: routeResolver.groupsOptions,
                phaseStatusOptions: routeResolver.phaseStatusOptions,
            },
            data: {
                pageTitle: 'dashboard_service',
                permissions: { dashboard_service__read_all: 0, dashboard_service__read: 'CUID' },
                dashboardType: 'service',
            },
        })

        // users

        .state('restricted.users', {
            url: '/users',
            views: {
                '': {
                    templateUrl: getView('users/users_list'),
                    controller: 'UsersListCtrl',
                    controllerAs: 'UsersList',
                },
            },
            resolve: {
                usersList: routeResolver.usersList,
                usersListFilter: routeResolver.usersListFilter,
            },
            data: {
                pageTitle: 'users',
                permissions: { users__read_all: 0, users__read: 'CUID' },
            },
        })
        .state('restricted.users_add', {
            url: '/users/add',
            views: {
                '': {
                    templateUrl: getView('users/users_edit'),
                    controller: 'EditUserCtrl',
                    controllerAs: 'EditUser',
                },
            },
            resolve: {
                userStatusOptions: routeResolver.userStatusOptions,
                permissionsList: routeResolver.permissionsList,
                groupsOptions: routeResolver.groupsOptions,
                areasOptions: routeResolver.areasOptions,
                jobsOptions: routeResolver.jobsOptions,
                userData: routeResolver.userData,
            },
            data: {
                pageTitle: 'users.add',
                parent: 'restricted.users',
                permissions: { users__write_all: 0, users__write: 'CUID' },
            },
        })
        .state('restricted.users_edit', {
            url: '/users/edit/:id',
            views: {
                '': {
                    templateUrl: getView('users/users_edit'),
                    controller: 'EditUserCtrl',
                    controllerAs: 'EditUser',
                },
            },
            resolve: {
                userStatusOptions: routeResolver.userStatusOptions,
                permissionsList: routeResolver.permissionsList,
                groupsOptions: routeResolver.groupsOptions,
                areasOptions: routeResolver.areasOptions,
                jobsOptions: routeResolver.jobsOptions,
                userData: routeResolver.userData,
            },
            data: {
                pageTitle: 'users.edit',
                parent: 'restricted.users',
            },
        })
        .state('restricted.users_mass', {
            url: '/users/mass-edit',
            views: {
                '': {
                    templateUrl: getView('users/users_mass_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'users.mass_edit',
                parent: 'restricted.users',
            },
        })

        // profile

        .state('restricted.profile', {
            url: '/profile',
            views: {
                '': {
                    templateUrl: getView('users/profile'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'users.profile',
                parent: 'restricted.users',
            },
        })

        // groups

        .state('restricted.groups', {
            url: '/groups',
            views: {
                '': {
                    templateUrl: getView('groups/groups_list'),
                    controller: 'GroupsListCtrl',
                    controllerAs: 'GroupsList',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
            },
            data: {
                pageTitle: 'groups',
            },
        })

        // dictionaries

        .state('restricted.dictionaries', {
            url: '/dictionaries',
            views: {
                '': {
                    templateUrl: getView('dictionaries/dictionaries_list'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'dictionaries',
            },
        })

        // attachments

        .state('restricted.attachments', {
            url: '/attachments',
            views: {
                '': {
                    templateUrl: getView('attachments/attachments_list'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'attachments',
            },
        })

        // clients

        .state('restricted.clients', {
            url: '/clients',
            views: {
                '': {
                    templateUrl: getView('clients/clients_list'),
                    controller: 'ClientsCtrl',
                    controllerAs: 'Clients',
                },
            },
            params: {
                filter: {},
            },
            resolve: {
                clientsList: routeResolver.clientsList,
                clientsListFilter: routeResolver.clientsListFilter,
            },
            data: {
                pageTitle: 'clients',
            },
        })
        .state('restricted.clients_add', {
            url: '/clients/add',
            views: {
                '': {
                    templateUrl: getView('clients/clients_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'clients.add',
                parent: 'restricted.clients',
            },
        })
        .state('restricted.clients_edit', {
            url: '/clients/edit/:id',
            views: {
                '': {
                    templateUrl: getView('clients/clients_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'clients.edit',
                parent: 'restricted.clients',
            },
        })
        .state('restricted.investments', {
            url: '/clients/investments',
            views: {
                '': {
                    templateUrl: getView('clients/client_investments'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'investments',
                parent: 'restricted.clients',
            },
        })

        // intrests

        .state('restricted.interests', {
            url: '/interests',
            views: {
                '': {
                    templateUrl: getView('interests/interests_list'),
                    controller: 'InterestsCtrl',
                    controllerAs: 'Interests',
                },
            },
            params: {
                filter: {},
            },
            resolve: {
                interestsListFilter: routeResolver.interestsListFilter,
                interestsList: routeResolver.interestsList,
            },
            data: {
                pageTitle: 'interests',
            },
        })
        .state('restricted.interests_add', {
            url: '/interests/add',
            views: {
                '': {
                    templateUrl: getView('interests/interests_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'interests.add',
                parent: 'restricted.interests',
            },
            params: {
                task: null,
                client: null,
                project: null,
            },
        })
        .state('restricted.interests_edit', {
            url: '/interests/edit/:id',
            views: {
                '': {
                    templateUrl: getView('interests/interests_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'interests.edit',
                parent: 'restricted.interests',
            },
        })

        // tasks

        .state('restricted.tasks', {
            url: '/tasks',
            views: {
                '': {
                    templateUrl: getView('tasks/tasks_list'),
                    controller: 'TasksCtrl',
                    controllerAs: 'Tasks',
                },
            },
            params: {
                filter: {},
            },
            resolve: {
                tasksList: routeResolver.tasksList,
                tasksListFilter: routeResolver.tasksListFilter,
            },
            data: {
                pageTitle: 'tasks',
            },
        })
        .state('restricted.tasks_add', {
            url: '/tasks/add',
            views: {
                '': {
                    templateUrl: getView('tasks/tasks_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'tasks.add',
                parent: 'restricted.tasks',
            },
            params: {
                client: null,
                interest: null,
                project: null,
            },
        })
        .state('restricted.tasks_edit', {
            url: '/tasks/edit/:id',
            views: {
                '': {
                    templateUrl: getView('tasks/tasks_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'tasks.edit',
                parent: 'restricted.tasks',
            },
        })

        // projects

        .state('restricted.projects', {
            url: '/projects',
            views: {
                '': {
                    templateUrl: getView('projects/projects_list'),
                    controller: 'ProjectsCtrl',
                    controllerAs: 'Projects',
                },
            },
            params: {
                filter: {},
            },
            resolve: {
                projectsList: routeResolver.projectsList,
                projectsListFilter: routeResolver.projectsListFilter,
            },
            data: {
                pageTitle: 'projects',
            },
        })
        .state('restricted.projects_add', {
            url: '/projects/add',
            views: {
                '': {
                    templateUrl: getView('projects/projects_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'projects.add',
                parent: 'restricted.projects',
            },
            params: {
                type: 'measurement',
                task: null,
                client: null,
                interest: null,
            },
        })
        .state('restricted.projects_edit', {
            url: '/projects/edit/:id',
            views: {
                '': {
                    templateUrl: getView('projects/projects_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'projects.edit',
                parent: 'restricted.projects',
            },
        })

        // phases

        .state('restricted.phases', {
            url: '/phases',
            views: {
                '': {
                    templateUrl: getView('phases/phases_list'),
                    controller: 'PhasesCtrl',
                    controllerAs: 'Phases',
                },
            },
            params: {
                filter: {},
            },
            resolve: {
                phasesList: routeResolver.phasesList,
                phasesListFilter: routeResolver.phasesListFilter,
            },
            data: {
                pageTitle: 'phases',
            },
        })
        .state('restricted.phases_add', {
            url: '/phases/add/:pid',
            views: {
                '': {
                    templateUrl: getView('phases/phases_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'phases.add',
                parent: 'restricted.phases',
            },
            params: {
                task: null,
                client: null,
                interest: null,
                project: null,
            },
        })
        .state('restricted.phases_edit', {
            url: '/phases/edit/:id',
            views: {
                '': {
                    templateUrl: getView('phases/phases_edit'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'phases.edit',
                parent: 'restricted.phases',
            },
        })
        .state('restricted.phases_print', {
            url: '/phases/print',
            views: {
                '': {
                    templateUrl: getView('phases/phases_print'),
                    controller: 'PrintPhasesCtrl',
                    controllerAs: 'PrintPhases',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
                groupsOptions: routeResolver.groupsOptions,
            },
            data: {
                pageTitle: 'phases.print',
                parent: 'restricted.phases',
            },
        })
        .state('restricted.phases_approval', {
            url: '/phases/approval/:type/:week',
            params: {
                type: {
                    value: 'installation',
                },
                week: {
                    value: moment().week().toString(),
                },
            },
            views: {
                '': {
                    templateUrl: getView('phases/phases_approval'),
                    controller: 'ApprovePhasesCtrl',
                    controllerAs: 'ApprovePhases',
                },
            },
            resolve: {},
            data: {
                pageTitle: 'phases.approvals',
                parent: 'restricted.phases',
            },
        })

        // reports

        .state('restricted.reports_period_summary', {
            url: '/reports/period_summary',
            views: {
                '': {
                    templateUrl: getView('reports/reports_period_summary'),
                    controller: 'ReportsPeriodSummaryCtrl',
                    controllerAs: 'ReportsPeriodSummary',
                },
            },
            resolve: {
                usersOptions: routeResolver.usersOptions,
                groupsOptions: routeResolver.groupsOptions,
                phaseStatusOptions: routeResolver.phaseStatusOptions,
            },
            data: {
                pageTitle: 'reports.period_summary',
                parent: 'restricted.reports',
            },
        })

        // areas

        .state('restricted.areas', {
            url: '/areas',
            views: {
                '': {
                    templateUrl: getView('areas/areas_list'),
                    controller: 'AreasListCtrl',
                    controllerAs: 'AreasList',
                },
            },
            resolve: {
                areasList: routeResolver.areasList,
            },
            data: {
                pageTitle: 'areas',
            },
        })
        .state('restricted.areas_add', {
            url: '/areas/add',
            views: {
                '': {
                    templateUrl: getView('areas/areas_edit'),
                    controller: 'EditAreaCtrl',
                    controllerAs: 'EditArea',
                },
            },
            resolve: {
                area() {
                    return {
                        id: 0,
                    };
                },
                allUserOptions: routeResolver.emptyArray,
                allGroupsOptions: routeResolver.emptyArray,
                installationOptions: routeResolver.emptyArray,
                woodworkOptions: routeResolver.emptyArray,
                currencyOptions: routeResolver.emptyArray,
                countryOptions: routeResolver.emptyArray,
                unitOptions: routeResolver.emptyArray,
                interestStatusOptions: routeResolver.emptyArray,
                taskStatusOptions: routeResolver.emptyArray,
                categoryOptions: routeResolver.emptyArray,
                projectStatusOptions: routeResolver.emptyArray,
                phaseStatusOptions: routeResolver.emptyArray,
            },
            data: {
                pageTitle: 'areas.add',
                parent: 'restricted.areas',
            },
            params: {},
        })
        .state('restricted.areas_edit', {
            url: '/areas/edit/:id',
            views: {
                '': {
                    templateUrl: getView('areas/areas_edit'),
                    controller: 'EditAreaCtrl',
                    controllerAs: 'EditArea',
                },
            },
            resolve: {
                area($stateParams, areasService) {
                    return areasService.find($stateParams.id);
                },
                allUserOptions: routeResolver.allUserOptions,
                allGroupsOptions: routeResolver.allGroupsOptions,
                installationOptions: routeResolver.installationOptions,
                woodworkOptions: routeResolver.woodworkOptions,
                currencyOptions: routeResolver.currencyOptions,
                countryOptions: routeResolver.countryOptions,
                unitOptions: routeResolver.unitOptions,
                interestStatusOptions: routeResolver.interestStatusOptions,
                taskStatusOptions: routeResolver.taskStatusOptions,
                categoryOptions: routeResolver.categoryOptions,
                projectStatusOptions: routeResolver.projectStatusOptions,
                phaseStatusOptions: routeResolver.phaseStatusOptions,
            },
            data: {
                pageTitle: 'areas.edit',
                parent: 'restricted.areas',
            },
        })

        // help

        .state('restricted.help', {
            url: '/help',
            views: {
                '': {
                    templateUrl: getView('help/help'),
                },
            },
            resolve: {},
            data: {
                pageTitle: 'help',
            },
        });

    // obsługa błędów
    $httpProvider.interceptors.push(($q, $sessionStorage) => ({
        responseError(response) {
            const deferred = $q.defer();

            // 401 unauthorized
            if ('.html' !== response.config.url.substr(-5, 5)) {
                if (401 === response.status) {
                    delete $sessionStorage.User;
                    deferred.reject(response);
                    window.location.reload();

                    return deferred.promise;
                }
            }

            deferred.resolve(response);

            return deferred.promise;
        },
    }));
});
